<!-- //
ftp列表管理
@auth xuyd
@date 2025-07-20
//-->
<template>
  <page-layout layout="C">
    <!-- 检索区域 -->
    <div class="layout-search flex-row flex-halign-between">
        <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
                 label-width="100px">
          <el-form-item prop="search">
            <el-input
                v-model="queryParams.search"
                placeholder="请输入监控的服务名称/IP/日志路径"
                style="width: 320px;text-align: right;"
                maxlength="20"
                clearable
                @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
            <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="display:flex; justify-content: right;">
          <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus">添加</el-button>
          <span v-for="(item, index) in messages" :key="index">
            {{ item }}
          </span>
        </div>
      </div>

    <div class="layout-result" style="height: calc(100% - 63px);">
      <DynamicTable :query-params="queryParams"
                    :selection="true"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
        <div slot-scope="{row, item}">
          <el-button size="small" type="text" @click="handleView(row)">探查记录</el-button>
          <el-button size="small" type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="text" @click="handleCopy(row)">复制</el-button>
          <el-button size="small" type="text" @click="handleDelete(row)">删除</el-button>
        </div>
      </DynamicTable>
    </div>
    <ChannelEdit ref="refChannelEdit"/>
  </page-layout>
</template>

<script>
import MonitorChannelApi from '@/api/sys/sysMonitorChannel.api.js';
import ChannelEdit from './edit';

export default {
  name: 'ViewMonitorChannelList',
  components: {ChannelEdit},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'HEALTHY_STATUS', dataType: Number}, // 健康状态
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
        monitorStatus: [],
      },
      messages: [],
      eventSource: null,
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      tableMetas: [
        {prop: 'serverName', label: "服务名称", minWidth: 120},
        {prop: 'serverIp', label: "IP地址", width: 100, sortable: true},
        {prop: 'status', label: "上线状态", width: 80, dataType: 'dict', dictType: 'YES_OR_NO'},
        {prop: 'logPath', label: "监控日志路径", minWidth: 220},
        {prop: 'monitorLogicDesc', label: "监控逻辑", minWidth: 120},
        {prop: 'cron', label: "CRON", width: 100},
        {prop: 'monitorEndTime', label: "最后探活时间", width: 170, dataType: 'date'},
        {prop: 'monitorStatus', label: "健康状态", width: 100, dataType: 'dict', dictType: 'HEALTHY_STATUS',
          filterable: true, filterComp: 'FunnelMultiSelect'},
        {prop: '', label: "操作", width: 180, fixed: 'right'},
      ]
    };
  },
  created() {
    this.handleInitConn();
    this.getList();
  },
  destroyed() {
    this.handleCloseConn();
  },
  methods: {
    getList() {
      MonitorChannelApi.searchMonitorServerList(this.queryParams).then(resp => {
        this.tableData.records = resp.data.records;
        this.tableData.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;
      // =========重置(S)========
      this.queryParams.monitorStatus = [];
      // =========重置(E)========
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleAdd() {
      this.$refs.refChannelEdit.showModal({
        data: {},
        onOk: (data) => {
          this.getList()
        }
      });
    },

    handleEdit(row) {
      this.$refs.refChannelEdit.showModal({
        mode: 2,
        title: '修改服务器',
        data: {...row},
        onOk: (data) => {
          this.getList()
        }
      });
    },
    handleCopy(row) {
      this.$refs.refChannelEdit.showModal({
        mode: 1,
        title: '新增服务器',
        data: {...row, id: null},
        onOk: (data) => {
          this.getList()
        }
      });
    },
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.serverName}】吗？`).then(() => {
        MonitorChannelApi.deleteMonitorServer(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },

    /**
     * 查看详情
     * @param row
     */
    handleView(row) {
      this.$router.push({
        name: "ViewMonitorTaskList",
        query: {id: row.id},
      });
    },

    /**
     * 初始化sse server sent event连接
     */
    handleInitConn() {
      this.eventSource = MonitorChannelApi.subscribeMonitorMessage(1);

      // 监听默认消息（type 为 "message"）
      this.eventSource.onmessage = (e) => {
        let data = e.data;
        console.log(this.$util.nowDate(), `收到消息: ${data}`);
        this.messages.push(data);
      };

      // 监听心跳事件
      this.eventSource.addEventListener(('heart'), (e) => {
        console.log(this.$util.nowDate(), `心跳: ${e.data}`);
      });

      // connect open
      this.eventSource.onopen = (e) => {
        console.log(this.$util.nowDate(), "server-sent event 连接建立", e)
      };

      // connect error
      this.eventSource.onerror = (e) => {
        console.log(this.$util.nowDate(), "server-sent event 连接错误", e)
      };
    },

    /**
     * close sse server sent event连接
     */
    handleCloseConn() {
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
        console.log(this.$util.nowDate(), "server-sent event 连接关闭")
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
